import React from 'react'
import moment from 'moment'
import _ from 'lodash'

export default function withInputDateTimeHandler(WrappedComponent) {
  return class InputDateTimeHandler extends React.Component {
    state = {
      value: this.props.value || moment(),
    }

    componentWillReceiveProps(nextProps) {
      if (!_.isEqual(nextProps.value, this.props.value)) {
        this.setState({
          value: nextProps.value,
        })
      }
    }

    handleSave = value => {
      this.setState({ value })
      if (this.props.onSave) {
        this.props.onSave(value)
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          onSave={this.handleSave}
          value={this.state.value}
        />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/calendar/withInputDateTimeHandler.js